(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c_hero-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setupSlider = (root) => {
    if (root.dataset.cInit) return;
    root.dataset.cInit = '1';

    const track = root.querySelector('[data-c-slider-track]');
    const slides = Array.from(root.querySelectorAll('[data-c-slide]'));
    if (!track || slides.length <= 1) return;

    const dotsWrap = root.querySelector('[data-c-slider-dots]');
    const dotLabel = dotsWrap ? dotsWrap.dataset.dotLabel || '' : '';
    const prev = root.querySelector('[data-c-slider-prev]');
    const next = root.querySelector('[data-c-slider-next]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let timer = null;

    const dots = slides.map((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'c_hero-slider__dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', dotLabel.replace('%s', String(i + 1)));
      dot.addEventListener('click', () => goTo(i, true));
      if (dotsWrap) dotsWrap.appendChild(dot);
      return dot;
    });

    const setActive = (i) => {
      index = i;
      dots.forEach((dot, di) => {
        dot.classList.toggle('is-active', di === i);
        dot.setAttribute('aria-selected', String(di === i));
      });
    };

    const goTo = (i, fromUser) => {
      const target = (i + slides.length) % slides.length;
      track.scrollTo({
        left: target * track.clientWidth,
        behavior: reduce.matches ? 'auto' : 'smooth',
      });
      setActive(target);
      if (fromUser) restart();
    };

    if (prev) prev.addEventListener('click', () => goTo(index - 1, true));
    if (next) next.addEventListener('click', () => goTo(index + 1, true));

    let raf = null;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        const clamped = Math.max(0, Math.min(slides.length - 1, i));
        if (clamped !== index) setActive(clamped);
      });
    });

    const interval = parseInt(root.dataset.autoplay, 10);
    const canAuto = interval > 0 && !reduce.matches;
    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    const start = () => {
      if (!canAuto) return;
      stop();
      timer = setInterval(() => goTo(index + 1, false), interval * 1000);
    };
    const restart = () => {
      stop();
      start();
    };

    ['mouseenter', 'focusin', 'pointerdown'].forEach((ev) => root.addEventListener(ev, stop));
    ['mouseleave', 'focusout'].forEach((ev) => root.addEventListener(ev, start));
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

    setActive(0);
    start();
  };

  const initSliders = (scope) => {
    (scope || document).querySelectorAll('[data-c-slider]').forEach(setupSlider);
  };

  document.addEventListener('DOMContentLoaded', () => initSliders(document));
  document.addEventListener('shopify:section:load', (event) => initSliders(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_main-article"]) return;
  try {
    
(() => {
  const MESSAGE_DURATION = 2000;
  let messageTimer;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-c-copy-url]');
    if (!button) return;

    const message = button.parentElement.querySelector('.c_main-article__copied');
    if (!message) return;

    clearTimeout(messageTimer);

    try {
      if (!navigator.clipboard) throw new Error('Clipboard API is unavailable');

      await navigator.clipboard.writeText(button.dataset.cCopyUrl);
      message.textContent = message.dataset.copiedMessage || '';
    } catch (error) {
      message.textContent = message.dataset.failedMessage || '';
    }

    messageTimer = window.setTimeout(() => {
      message.textContent = '';
    }, MESSAGE_DURATION);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_product-rails"] && !Shopify.designMode) return;
  try {
    
(() => {
  const KEY = 'c_recently_viewed';
  const AJAX_SECTION = 'c_product-card-ajax';

  const readList = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };

  const rootPath = () =>
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const fetchCard = async (handle) => {
    try {
      const res = await fetch(`${rootPath()}products/${handle}?section_id=${AJAX_SECTION}`);
      if (!res.ok) return null;
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      return doc.querySelector('.c_card-ajax');
    } catch (error) {
      return null;
    }
  };

  const initRail = async (scope) => {
    const rail = (scope || document).querySelector('[data-c-recently-viewed]');
    if (!rail || rail.dataset.cInit) return;
    rail.dataset.cInit = '1';

    const grid = rail.querySelector('[data-c-rv-grid]');
    const limit = parseInt(rail.dataset.limit, 10) || 4;
    const section = rail.closest('.c_product-rails');
    const current = section ? section.dataset.cCurrentHandle : '';

    const handles = readList()
      .filter((handle) => handle !== current)
      .slice(0, limit);
    if (!handles.length) return;

    const cards = await Promise.all(handles.map(fetchCard));
    cards.filter(Boolean).forEach((card) => {
      const li = document.createElement('li');
      li.className = 'c_rail__item';
      li.appendChild(card);
      grid.appendChild(li);
    });

    if (grid.children.length > 0) rail.hidden = false;
  };

  const boot = () => {
    initRail(document);
  };

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => initRail(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_sticky-atc"] && !Shopify.designMode) return;
  try {
    
(() => {
  const PRODUCT_INFO_SELECTOR = 'product-info[id^="MainProduct-"]';
  const PRODUCT_FORM_SELECTOR = 'product-form';
  const MAIN_BUTTON_SELECTOR = '[name="add"]';
  const PRICE_SELECTOR = '.price';
  const SALE_PRICE_SELECTOR = '.price__sale .price-item--sale';
  const REGULAR_PRICE_SELECTOR = '.price__regular .price-item--regular';
  const TAX_SELECTOR = '.c_price-tax';
  const VARIANT_SELECTOR = 'variant-selects';
  const SELECTED_RADIO_SELECTOR = 'variant-selects input[type="radio"]:checked';
  const AVAILABLE_RADIO_SELECTOR = 'input[type="radio"]:not(.disabled):not(:disabled)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const AWAITING_SELECTION_ATTRIBUTE = 'data-c-awaiting-selection';

  // 商品本体の購入状態と価格を固定ボタンへ反映する。
  const initStickyAtc = () => {
    const bar = document.querySelector('[data-c-sticky-atc]');
    if (!bar || bar.dataset.cInit) return;

    const productInfo = document.querySelector(PRODUCT_INFO_SELECTOR);
    const productForm = productInfo?.querySelector(PRODUCT_FORM_SELECTOR);
    const mainButton = productForm?.querySelector(MAIN_BUTTON_SELECTOR);
    if (!productInfo || !productForm || !mainButton) {
      bar.closest('.c_sticky-atc-section')?.remove();
      return;
    }

    bar.dataset.cInit = '1';
    document.body.classList.add('c_has-sticky-atc');
    const stickyButton = bar.querySelector('[data-c-sticky-add]');
    const priceRegion = productInfo.querySelector(`#price-${productInfo.dataset.section}`);

    // 価格内の税込表示を除いて、現在表示中の販売価格を返す。
    const getVisiblePrice = () => {
      if (!priceRegion) return '';
      const price = priceRegion.querySelector(PRICE_SELECTOR);
      const priceItem = price?.classList.contains('price--on-sale')
        ? priceRegion.querySelector(SALE_PRICE_SELECTOR)
        : priceRegion.querySelector(REGULAR_PRICE_SELECTOR);
      if (!priceItem) return '';
      const priceCopy = priceItem.cloneNode(true);
      priceCopy.querySelectorAll(TAX_SELECTOR).forEach((tax) => tax.remove());
      return priceCopy.textContent.trim();
    };

    // 未選択、購入可能、購入不可の順にボタン状態を揃える。
    const syncState = () => {
      const hasSelectedOption = Boolean(productInfo.querySelector(SELECTED_RADIO_SELECTOR));
      if (productForm.hasAttribute(AWAITING_SELECTION_ATTRIBUTE) && !hasSelectedOption) {
        stickyButton.disabled = false;
        stickyButton.textContent = bar.dataset.cSelectLabel;
        return;
      }

      if (mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') {
        stickyButton.disabled = true;
        stickyButton.textContent = mainButton.querySelector('span')?.textContent.trim() || mainButton.textContent.trim();
        return;
      }

      stickyButton.disabled = false;
      const price = getVisiblePrice();
      stickyButton.textContent = price ? `${bar.dataset.cAddLabel} ${price}` : bar.dataset.cAddLabel;
    };

    stickyButton.addEventListener('click', () => {
      const hasSelectedOption = Boolean(productInfo.querySelector(SELECTED_RADIO_SELECTOR));
      if (productForm.hasAttribute(AWAITING_SELECTION_ATTRIBUTE) && !hasSelectedOption) {
        const variantSelects = productInfo.querySelector(VARIANT_SELECTOR);
        if (!variantSelects) return;
        variantSelects.scrollIntoView({
          behavior: window.matchMedia(REDUCED_MOTION_QUERY).matches ? 'auto' : 'smooth',
          block: 'center',
        });
        variantSelects.querySelector(AVAILABLE_RADIO_SELECTOR)?.focus({ preventScroll: true });
        return;
      }
      if (!stickyButton.disabled) mainButton.click();
    });

    syncState();

    const observer = new MutationObserver(syncState);
    observer.observe(productForm, { attributes: true, attributeFilter: [AWAITING_SELECTION_ATTRIBUTE] });
    observer.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    if (priceRegion) observer.observe(priceRegion, { childList: true, subtree: true, characterData: true });

    const visibility = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('c_sticky-atc--visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -10% 0px' },
    );
    visibility.observe(mainButton);
  };

  document.addEventListener('DOMContentLoaded', initStickyAtc);
  document.addEventListener('shopify:section:load', initStickyAtc);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
